module.exports = [
    "Male",
    "Female",
    "Other",
    "Uninformed"
]